import { GreyChipButton } from '@/components/ui/generic/grey-chip-button';
import { createFileRoute } from '@tanstack/react-router';
import { CircleFadingArrowUpIcon } from 'lucide-react';

const ComponentsPage = () => {
  return (
    <div className="h-full overflow-y-auto">
      <div className="w-full max-w-6xl mx-auto p-6 dark:bg-dark">
        <div className="mb-8">
          <h1 className="text-3xl  text-gray-900 dark:text-white mb-2">
            Component Examples
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            A collection of UI components to help you build Paddock
          </p>
        </div>

        {/* Brand Palette Section squares of our colors with text labels i.e. Accent, Neutral, etc. */}
        <section className="mb-12">
          <h2 className="text-2xl  text-gray-800 dark:text-white mb-6">
            Brand Palette
          </h2>
          <a
            href="https://www.figma.com/design/9DQrRCXnzjztypuVwlR5EK/Product-Prototypes---evercars.com---Web-Application?node-id=62-7&p=f&t=jiS5eXZX5x6Y8iGs-0"
            target="_blank"
            rel="noopener noreferrer"
          >
            View in Figma
          </a>
          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex flex-wrap gap-4">
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Ever Green (#44F0B3)
                </span>
                <div className="w-16 h-16 bg-[#44F0B3] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Medium Green (#28C999)
                </span>
                <div className="w-16 h-16 bg-[#28C999] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Buttons Green (#1BB687)
                </span>
                <div className="w-16 h-16 bg-[#1BB682] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Midnight Green (#184346)
                </span>
                <div className="w-16 h-16 bg-[#184346] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Safety Orange (#FF8E3F)
                </span>
                <div className="w-16 h-16 bg-[#FF8E3F] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Text Color - Jet Black (#232323)
                </span>
                <div className="w-16 h-16 bg-[#232323] rounded-md"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Palette Section squares of our colors with text labels i.e. Accent, Neutral, etc. */}
        <section className="mb-12">
          <h2 className="text-2xl  text-gray-800 dark:text-white mb-6">
            Radix Palette (evercars.com)
          </h2>
          <a
            href="https://www.figma.com/design/fblhbzF60XkiZwf7V13UR3/Radix-3.0?t=jiS5eXZX5x6Y8iGs-0"
            target="_blank"
            rel="noopener noreferrer"
          >
            View in Figma
          </a>
          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex flex-wrap gap-4">
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Accent (#2CE685)
                </span>
                <div className="w-16 h-16 bg-[#2CE685] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Neutral (#8A8D8E)
                </span>
                <div className="w-16 h-16 bg-[#8A8D8E] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Semantic Error (#FFCE21)
                </span>
                <div className="w-16 h-16 bg-[#FFCE21] rounded-md"></div>
              </div>
              <div>
                <span className="text-xs text-gray-600 dark:text-gray-400">
                  Semantic Warning (#4CEBF7)
                </span>
                <div className="w-16 h-16 bg-[#4CEBF7] rounded-md"></div>
              </div>
            </div>
          </div>
        </section>

        {/* Buttons Section */}
        <section className="mb-12">
          <h2 className="text-2xl  text-gray-800 dark:text-white mb-6">
            Buttons
          </h2>
          <div className="flex flex-col gap-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex gap-4">
              <GreyChipButton
                iconNode={<CircleFadingArrowUpIcon />}
                label="Chip with icon"
              />
              <GreyChipButton label="Chip without icon" />
              <GreyChipButton
                iconNode={<CircleFadingArrowUpIcon />}
                label="Active chip"
                active
              />
            </div>
          </div>
        </section>

        {/* Dropdowns Section */}
        <section className="mb-12">
          <h2 className="text-2xl  text-gray-800 dark:text-white mb-6">
            Dropdowns
          </h2>
          <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-6">
            <div className="flex flex-wrap gap-4"></div>
          </div>
        </section>
      </div>
    </div>
  );
};

export const Route = createFileRoute('/(authenticated)/components/')({
  component: ComponentsPage,
});
